import { render } from "./XIconSolidRadar.vue?vue&type=template&id=66b8dadc"
import script from "./XIconSolidRadar.vue?vue&type=script&lang=js"
export * from "./XIconSolidRadar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidRadar.vue"]])

export default __exports__